module.exports = __webpack_public_path__ + "img/image-12.19a864dc.png";